module.exports = __webpack_public_path__ + "media/images/country_flags/no-5948449b65d6d3a39b9c64300cb12fbe.png";